import { createContext } from "react";
import swal from "sweetalert";

export const apiUrl = process.env.REACT_APP_API_URL;

export const frontendUrl = process.env.REACT_APP_FRONTEND_URL;

export const DATE_OPTIONS = {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
}

export const length_unit = "Ft"
export const MyContext = createContext();
export const Unauthorized=()=>{swal({ icon: 'error', text: "Unauthorized", button: "OK" }).then(() => {
    localStorage.clear()
    window.location.href = "/";
    console.log('OK button clicked after error alert');
})}
